export enum SettingsTab {
  General = 'general',
  Credit = 'credit',
  Mail = 'mail',
  Security = 'security',
  Verification = 'verification',
  Delete = 'delete',
  Addresses = 'addresses'
}
